export default "__VITE_ASSET__cf7daef9__"